var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"gw-headline__dropdown-item",attrs:{"href":_vm.getHref,"target":_vm.getTarget},on:{"click":function($event){return _vm.click($event)}}},[_c('span',[_vm._v(_vm._s(_vm.link.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }